export class PushCartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.syncSource()) {
      this.clear()
      return
    }

    this.renderTimeout = window.setTimeout(() => this.render(), 500)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.clearTimeout(this.renderTimeout)
    this.renderVersion = (this.renderVersion ?? 0) + 1
    this.expanded = false
  }

  render () {
    const productId = this.syncSource()
    if (!productId) {
      this.clear()
      return
    }

    const renderVersion = (this.renderVersion ?? 0) + 1
    this.renderVersion = renderVersion

    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        if (!this.isConnected || this.renderVersion !== renderVersion) return

        const currentSource = window.BAO.Cart?.recommendationSourceProductId
        if (
          window.BAO.Cart &&
          String(currentSource ?? '') !== productId
        ) {
          return
        }

        const html = document.createElement('div')
        html.innerHTML = text

        const recommendations = html.querySelector('push-cart-recommendations')
        const hasItems =
          recommendations && recommendations.innerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('.psh-Recommendations')
            .forEach((container) => {
              container.innerHTML = recommendations.innerHTML
            })
        } else {
          this.clear()
          return
        }

        this.expanded = true
      })
      .catch((e) => {
        if (!this.isConnected || this.renderVersion !== renderVersion) return
        console.error(e)
      })
  }

  /**
   * Use the paid add tracked by BaoCart rather than Shopify's cart line
   * order, which does not move a line when an existing variant is re-added.
   *
   * @returns {string|null}
   */
  syncSource () {
    const source = window.BAO.Cart?.recommendationSourceProductId ??
      this.dataset.productId
    const productId = source ? String(source) : null

    if (!productId) {
      this.dataset.productId = ''
      return null
    }

    const url = new URL(this.dataset.url, window.location.origin)
    url.searchParams.set('product_id', productId)

    this.dataset.productId = productId
    this.dataset.url = `${url.pathname}${url.search}`

    return productId
  }

  clear () {
    document
      .querySelectorAll('.psh-Recommendations')
      .forEach((container) => {
        container.innerHTML = ''
      })

    this.expanded = false
  }

  get expanded () {
    return this._expanded
  }

  set expanded (expanded) {
    this._expanded = expanded

    document
      .querySelector('.drw-Drawer[data-module-drawers-drawer="cart"] .drw-Drawer_Aside')
      ?.setAttribute('aria-expanded', expanded)

    document
      .querySelector('.psh-Cart_Recommendations')
      ?.setAttribute('loaded', expanded)
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}

const { debounce } = window.BAO.Utils

class PushCartRecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Start hidden until carousel is initialized
    if (this.els?.slides?.element) {
      this.els.slides.element.setAttribute('data-initialised', 'false')
    }

    this.handleResize = this.handleResize.bind(this)
    this.debouncedHandleResize = debounce(this.handleResize, 50)

    window.addEventListener('resize', this.debouncedHandleResize)

    this.renderTimeout = window.setTimeout(() => this.render(), 500)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.clearTimeout(this.renderTimeout)
    window.removeEventListener('resize', this.debouncedHandleResize)
    this.destroyCarousel()
  }

  handleResize () {
    if (!this.isConnected) return
    if (!this.els?.slide?.exists) return

    const shouldHaveCarousel = !window.BAO.MediaBreakpoints.isMd

    if (shouldHaveCarousel && !this.carousel) {
      this.carousel = this.setupCarousel()
    } else if (!shouldHaveCarousel && this.carousel) {
      this.destroyCarousel()
    }
  }

  render () {
    if (!this.els?.slide?.exists) return

    if (window.BAO.MediaBreakpoints.isMd) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const carousel = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.5,
          spacing: 15,
        },
        created: (slider) => {
          slider.container.setAttribute('data-initialised', 'true')
          document.querySelector('.psh-Cart_Recommendations')?.setAttribute('data-loaded', 'true')
        },
      },
    )

    return carousel
  }

  destroyCarousel () {
    if (!this.carousel) return

    this.carousel.destroy(true)
    this.carousel = null

    // Reset attributes when carousel is destroyed
    if (this.els?.slides?.element) {
      this.els.slides.element.setAttribute('data-initialised', 'false')
    }
    document.querySelector('.psh-Cart_Recommendations')?.setAttribute('data-loaded', 'false')
  }
}

if (!customElements.get('push-cart-recommendations-carousel')) {
  customElements.define(
    'push-cart-recommendations-carousel',
    PushCartRecommendationsCarousel,
  )
}
